import { useUserData } from '../../../hooks'
import { isStaffUser } from '../../../utils/user'
import { HelpButton } from '../../HelpButton'
import { HelpLink } from '../../HelpLink'

function LayoutHelp() {
  const user = useUserData()

  return isStaffUser(user) ? <HelpButton /> : <HelpLink />
}

export default LayoutHelp
